import { create } from "zustand"

import type { Invoice } from "@be-miniapp/api"

interface RideOptionFormState {
  note: string | undefined
  isNoteConfirmed: boolean
  invoiceChecked: boolean
  setInvoiceChecked: (invoiceChecked: boolean) => void
  lastFormState: {
    note: string | undefined
    invoice: Invoice | undefined
    isChecked: boolean
  }
  setLastFormState: (
    lastFormState: Partial<RideOptionFormState["lastFormState"]>
  ) => void
  setNote: (note: string | undefined) => void
  setIsNoteConfirmed: (checked: boolean) => void
  reset: () => void
}

const initialState: Partial<RideOptionFormState> = {
  invoiceChecked: false,
  lastFormState: {
    note: undefined,
    invoice: undefined,
    isChecked: false,
  },
  note: "",
  isNoteConfirmed: false,
}

const useRideOptionFormState = create<RideOptionFormState>((set) => ({
  ...(initialState as any),
  setInvoiceChecked(checked: boolean) {
    set({ invoiceChecked: checked })
  },
  setNote(note: string | undefined) {
    set({ note })
  },
  setIsNoteConfirmed(checked: boolean) {
    set({ isNoteConfirmed: checked })
  },
  setLastFormState(
    lastFormState: Partial<RideOptionFormState["lastFormState"]>
  ) {
    set({ lastFormState } as any)
  },
  reset() {
    set({
      ...(initialState as any),
    })
  },
}))

export { useRideOptionFormState }
